import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GeneralServiceService } from 'src/app/services/general-service.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { PagerService } from 'src/app/services/pager.service';

interface FoodNode {
  idcat: string;
  titolo: string;
  level: string;
  children?: FoodNode[];
}

interface FoodNode2 {
  
  name: string;
  children?: FoodNode2[];
}



interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  idcat: string;
  level: number;
}
@Component({
  selector: 'app-elenco-prodotti',
  templateUrl: './elenco-prodotti.component.html',
  styleUrls: ['./elenco-prodotti.component.scss']
})
export class ElencoProdottiComponent implements OnInit {
  typeVis: any = 'icon';
  paramSearch: any = "";
  paramCat: any = "";
  arrProdotti: any[]=[];
  titoloProd: any = "";
  TREE_DATA: FoodNode[] = [];
  pag: any = 1;
  pager: any = {};
  totPage: any = 0;
  messaggio: string = "";
  // paged items
  pagedItems: any[];
  loggato: boolean = false;
  currentPage: any;
  limitProd: any = 99;
  totProd: any;
  idcat: any = "";
  level: any = '';
  sort: any = "nrigaoff";
  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.titolo,
      idcat: node.idcat,
      level: level,
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, public genericFunc: GeneralServiceService,
    private pagerService: PagerService, private local: LocalStorageService, private toastr: ToastrService) {

    
   }
  
  ngOnInit(): void {

   
   
    this.activatedRoute.paramMap.subscribe(params => {
      this.paramSearch = params.get("paramSearch");
      this.paramCat = params.get("paramCat");
      let level = params.get("livelloCat");
      console.log(this.paramCat);
      if (this.local.getLocal('username') != "" && this.local.getLocal('username') != null && this.local.getLocal('username') != 'null') {
        let datiLogin = {func: 'checkToken', token: this.local.getLocal('token'), idut: this.local.getLocal('idut'), deviceId: ''}
        this.genericFunc.genericFunction(datiLogin).subscribe( response => {
          console.log(response);
          if (response.login == 1) {
            this.genericFunc.currentUser = response;
            console.log(this.genericFunc.currentUser);
            this.genericFunc.currentToken = response['token'];
            this.genericFunc.idCart = response['idcar'];
            this.genericFunc.totCart = response.TotProdCar;
            this.genericFunc.minimoOrd = response.MinimoOrd;
            this.genericFunc.estero = response.estero;
            this.genericFunc.changeItemCart(response.TotProdCar);
            
            
            this.genericFunc.changeLoggato(true);
            this.genericFunc.changeCurrentUser(response);
            if (this.paramCat) {
              this.searchCat(this.paramCat, level);
            } else {
              this.getResult();
            }
            


            this.loggato = this.genericFunc.loggato;
            
            this.genericFunc.subjectLoggato.subscribe((loggatoNew: boolean) => {
              this.loggato = loggatoNew;
              console.log(this.loggato);
            });

            
          } else {
            this.genericFunc.loggato = false;
            this.genericFunc.currentToken = '';
            this.genericFunc.idCart = '';
            //this.router.navigateByUrl('accedi');
            this.genericFunc.changeLoggato(false);
            
            if (this.paramCat) {
              this.searchCat(this.paramCat, level);
            } else {
              this.getResult();
            }
            
            
          }
        });
      } else {
        if (this.paramCat) {
          
          this.searchCat(this.paramCat, level);
        } else {
          this.getResult();
        }
        
        
      }


      
      this.getCategorie();
   })
  /*   this.paramSearch = this.activatedRoute.snapshot.paramMap.get('paramSearch');
    this.getResult();
    this.getCategorie(); */
  }

  getResult() {
    let datiRicerca = {func: "ElencoProd", riclib: this.paramSearch, pag: this.pag, livello: this.level, idcat: this.idcat, idut: this.genericFunc.currentUser.idut, prodLimit: this.limitProd, ordi: this.sort};
    this.genericFunc.genericFunction(datiRicerca).subscribe(response => {
      if (response.messaggio == "ok") {
        this.arrProdotti = response.skprod;
        this.totPage = response.totPag;
        this.totProd = response.totProd;
        for (let i = 0; i < this.arrProdotti.length; i++) {
          this.arrProdotti[i].qty = 1;
          
        }
        console.log(response);
        this.setPage(this.pag);
      } else {
        this.arrProdotti = [];
        this.messaggio = response.messaggio;
      }
      
    });
  }

  sortProdotti(sortT: any) {
    console.log(sortT);
    this.sort = sortT;
    this.getResult();
  }

  getCategorie() {
    let dataCategorie = {func:"CatSideBar", idvol: ""};
    this.genericFunc.genericFunction(dataCategorie).subscribe( response => {
      console.log(response);
      this.TREE_DATA = response.Categorie;
      this.dataSource.data = this.TREE_DATA;
      
      console.log(this.TREE_DATA);
    });
  }

  searchCat(idcat, level) {
    console.log(idcat + " - " + level);
    this.arrProdotti = [];
    this.idcat = idcat;
      this.level = level;
    let datiRicerca = {func: "ElencoProd", idcat: idcat, livello: level, idut: this.genericFunc.currentUser.idut, pag: 1};
    this.genericFunc.genericFunction(datiRicerca).subscribe(response => {
      if (response.messaggio == "ok") {
        this.arrProdotti = response.skprod;
        this.totPage = response.totPag;
        this.totProd = response.totProd;
        for (let i = 0; i < this.arrProdotti.length; i++) {
          this.arrProdotti[i].qty = 1;
          
        }
        console.log(response);
        this.setPage(this.pag);
      } else {
        this.arrProdotti = [];
        this.messaggio = response.messaggio;
      }
    });
  }

  setPage(page: number) {
    // get pager object from service
    this.pager = this.pagerService.getPager(this.totPage, page);
    console.log(this.pager);
    // get current page of itemsthis.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
}

getPage(i) {
this.pag = i;
this.getResult();
this.gotoTop();
//this.setPage(i);
}

prevPage() {
this.pag = this.pag -1;
this.getResult();
this.gotoTop();
//this.setPage(this.pag);
}

nextPage() {
this.pag = this.pag + 1;
this.getResult();
this.gotoTop();
//this.setPage(this.pag);
}

  gotoTop() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  changeVis(tipoVista) {
    this.typeVis = tipoVista;
  }

  addQty(index) {
    this.arrProdotti[index].qty = this.arrProdotti[index].qty + 1;
  }

  removeQty(index) {
    if (this.arrProdotti[index].qty > 1 ) {
      this.arrProdotti[index].qty = this.arrProdotti[index].qty - 1;
    }
  }

  addCart(prodotto) {
    let datiCart = {func: "aggCar", id: prodotto.idprod, qta: prodotto.qty, idcar: this.genericFunc.idCart, idut: this.genericFunc.currentUser.idut, token: this.genericFunc.currentToken}
    this.genericFunc.genericFunction(datiCart).subscribe(response => {
     console.log(response);
     if (response.Esito == "ok") {
       this.toastr.success(response.messaggio);
       this.genericFunc.totCart = response.totProdCar;
       this.genericFunc.idCart = response.idcarrello;
       this.genericFunc.changeItemCart(response.totProdCar);
     } else {
       this.toastr.error(response.messaggio);
     }
    });
  }

  setLimit() {
    this.getResult();
  }


}
